import React, { useEffect, useState } from "react";
import axios from "axios";
import AspirasiBerandaSkeleton from "../../../../Components/loading/skeletonBeranda";
const FaEye = require("react-icons/fa").FaEye;

interface LastVoter {
  user_id: number;
  user_name: string;
  vote_value: number;
  time: string;
  presiden_id: number;
  presiden: string;
  jabatan: string;
  pertanyaan: string;
}

const TableVoteBeranda = () => {
  const [lastVoters, setLastVoters] = useState<LastVoter[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedVoter, setSelectedVoter] = useState<LastVoter | null>(null);

  const fetchSummary = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/quisioners/summary`);
      setLastVoters(res.data.last_voters || []);
    } catch (err) {
      console.error("Gagal fetch quisioner summary:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  const renderStars = (nilai: number) => {
    return "⭐".repeat(nilai);
  };

  if (loading)
    return (
      <div>
        <AspirasiBerandaSkeleton />
      </div>
    );

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-lg font-bold mb-4">Voter Terbaru</h2>
      <table className="w-full border border-gray-200">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2">No</th>
            <th className="px-4 py-2">Nama</th>
            <th className="px-4 py-2">Kepada</th>
            <th className="px-4 py-2">Nilai Vote</th>
            <th className="px-4 py-2">Tanggal</th>
            <th className="px-4 py-2">Detail</th>
          </tr>
        </thead>
        <tbody>
          {lastVoters.length > 0 ? (
            lastVoters.map((voter, idx) => (
              <tr key={idx} className="border-b text-center">
                <td className="px-4 py-2">{idx + 1}</td>
                <td className="px-4 py-2">{voter.user_name}</td>
                <td className="px-4 py-2">{voter.presiden}</td>

                <td className="px-4 py-2">{renderStars(Number(voter.vote_value))}</td>
                <td className="px-4 py-2">{new Date(voter.time).toLocaleString()}</td>
                <td className="px-4 py-2">
                  <button onClick={() => setSelectedVoter(voter)} className="text-primary hover:underline text-lg">
                    <FaEye />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center py-4">
                Tidak ada data voter terakhir
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Modal Detail */}
      {selectedVoter && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
            <h3 className="text-lg font-bold mb-4">Detail Vote</h3>
            <div className="flex justify-between">
              <strong>Nama :</strong> {selectedVoter.user_name}
            </div>
            <div className="flex justify-between">
              <strong>Pejabat :</strong> {selectedVoter.presiden}
            </div>
            <div className="flex justify-between">
              <strong>Jabatan :</strong> {selectedVoter.jabatan}
            </div>
            <div className="">
              <strong>Pertanyaan :</strong> {selectedVoter.pertanyaan}
            </div>
            <div className="flex justify-between">
              <strong>Vote :</strong> {renderStars(Number(selectedVoter.vote_value))}
            </div>
            <div className="flex justify-between">
              <strong>Waktu :</strong> {new Date(selectedVoter.time).toLocaleString()}
            </div>

            <div className="mt-6 flex justify-end">
              <button onClick={() => setSelectedVoter(null)} className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableVoteBeranda;
